import React from 'react';
import { Box } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import { ParkingLocation } from '../../types/parkingLocation';
import { buildPipeline, StageDefinition } from '../../flow/stages';
import FlowStepperRenderer from './FlowStepperRenderer';

interface FlowPreviewProps {
	lot: Partial<ParkingLocation> | null;
}

// Synthetic entry-point step shown only in the admin preview. The scan
// happens pre-drawer, so it's not in the in-app pipeline — but operators
// reading the admin preview benefit from seeing the full journey, scan
// included. The `id` is a sentinel string never used by the renderer
// beyond the React key.
const SCAN_ENTRY: StageDefinition = {
	id: 'scan' as unknown as StageDefinition['id'],
	label: 'Scan plate',
	shortLabel: 'Scan',
	icon: QrCodeScannerIcon,
	visible: () => true,
};

const FlowPreview: React.FC<FlowPreviewProps> = ({ lot }) => {
	const pipeline = [
		SCAN_ENTRY,
		...buildPipeline(lot as ParkingLocation | null),
	];

	return (
		<Box sx={{ pointerEvents: 'none', userSelect: 'none', py: 1 }}>
			<FlowStepperRenderer
				pipeline={pipeline}
				currentIndex={-1}
				currentBranchId={null}
				showTowBranch={true}
			/>
		</Box>
	);
};

export default FlowPreview;
